export default __webpack_public_path__ + "static/Cashflow 101+202-0-a43fdc598ae6272075e1898cf1cf3348.jpg";